import { Contract } from "ethers";
import { ethers } from "ethers";

import toast from "react-hot-toast";
import {
  SFM_SPACESHIP_CONTRACT_ADDRESS,
  SFM_SPACESHIP_CONTRACT_ABI,
} from "./SFM-SpaceshipConstants";

// Connect to the Base Sepolia testnet
// const provider = new ethers.providers.BaseSepoliaProvider();
// const signer = provider.getSigner();

export async function mintSpaceship(nft) {
  // Get the Metamask provider
  const provider = new ethers.providers.Web3Provider(window.ethereum);
  const chainID = (await provider.getNetwork()).chainId;
  if (chainID === 84532) {
    const signer = provider.getSigner();
    const address = await signer.getAddress();
    // Connect to the Contract
    const contract = new Contract(
      SFM_SPACESHIP_CONTRACT_ADDRESS,
      SFM_SPACESHIP_CONTRACT_ABI,
      signer
    );

    try {
      // Contract Properties struct only has: speed, fireCapacity, maxWeapons, maxShields, maxFuel
      const properties = {
        speed: nft.properties.speed,
        fireCapacity: nft.properties.fireCapacity,
        maxWeapons: nft.properties.maxWeapons,
        maxShields: nft.properties.maxShields,
        maxFuel: nft.properties.maxFuel,
      };
      const tx = await contract.safeMint(
        address,
        nft.uri,
        nft.name,
        nft.image,
        nft.sprite_photo,
        nft.properties.level,
        nft.sound,
        properties
      );
      toast.promise(tx.wait(), {
        loading: "Buying NFT",
        success: displayMessageWithLink(tx.hash),
        error: "Buying failed",
      });
    } catch (e) {
      console.log(e);
      toast.error("Buying failed");
    }
  } else {
    toast.error("Please connect to Base Sepolia Testnet");
  }
}

export const getSpaceships = async () => {
  const provider = new ethers.providers.Web3Provider(window.ethereum);
  const chainID = (await provider.getNetwork()).chainId;
  if (chainID === 84532) {
    const signer = provider.getSigner();
    const address = await signer.getAddress();
    // Connect to the Contract
    const contract = new Contract(
      SFM_SPACESHIP_CONTRACT_ADDRESS,
      SFM_SPACESHIP_CONTRACT_ABI,
      signer
    );

    const nfts = await contract.getNftsbyOwner(address);

    return nfts;
  } else {
    toast.error("Please connect to Base Sepolia Testnet");
  }
};

const displayMessageWithLink = (hash) => (
  <div>
    Buying success! for transaction{" "}
    <a
      href={`https://sepolia.basescan.org/tx/${hash}`}
      target="_blank"
      rel="noreferrer"
    >
      Click Here
    </a>
  </div>
);
